const BASE = `/admin`;

export const SCREENS = {
  REST: () => `*`,
  ROOT: () => `${BASE}/`,
  LOGIN: () => `${BASE}/login`,

  HISTORY: () => `${BASE}/history`,
  HISTORY_ORDER_VIEW: (id: string) => `${BASE}/history/${id}`,
  HISTORY_ORDER_EDIT: (id: string) => `${BASE}/history/${id}/edit`,
  HISTORY_ORDER_LOGS: (id: string | number) => `${BASE}/history/${id}/logs`,
  HISTORY_ORDER_TECHNICAL_LOGS: (id: string | number) => `${BASE}/history/${id}/technical-logs`,
  HISTORY_ORDER_TRANSACTION_LOGS: (id: string | number) => `${BASE}/history/${id}/transaction-logs`,
  HISTORY_ORDER_CONTENT_LOGS: (id: string | number) => `${BASE}/history/${id}/content-logs`,

  LIVE_ORDERS: () => `${BASE}/orders`,
  LIVE_ORDER: (id: string | number, reg: string = '') => `${BASE}/orders/${id}${reg}`,
  LIVE_ORDER_EDIT: (id: string | number) => `${BASE}/orders/${id}/edit`,
  LIVE_ORDER_LOGS: (id: string | number) => `${BASE}/orders/${id}/logs`,
  LIVE_ORDER_TECHNICAL_LOGS: (id: string | number) => `${BASE}/orders/${id}/technical-logs`,
  LIVE_ORDER_TRANSACTION_LOGS: (id: string | number) => `${BASE}/orders/${id}/transaction-logs`,
  LIVE_ORDER_CONTENT_LOGS: (id: string | number) => `${BASE}/orders/${id}/content-logs`,

  CALLCENTER: () => `${BASE}/callcenter`,
  CALLCENTER_ORDER: (id: string | number, reg: string = '') => `${BASE}/callcenter/orders/${id}${reg}`,
  CALLCENTER_ORDER_EDIT: (id: string | number) => `${BASE}/callcenter/orders/${id}/edit`,
  CALLCENTER_ORDER_LOGS: (id: string | number) => `${BASE}/callcenter/orders/${id}/logs`,
  CALLCENTER_ORDER_TECHNICAL_LOGS: (id: string | number) => `${BASE}/callcenter/orders/${id}/technical-logs`,
  CALLCENTER_ORDER_TRANSACTION_LOGS: (id: string | number) => `${BASE}/callcenter/orders/${id}/transaction-logs`,
  CALLCENTER_ORDER_CONTENT_LOGS: (id: string | number) => `${BASE}/callcenter/orders/${id}/content-logs`,

  DASHBOARD: () => `${BASE}/dashboard`,

  ITEMS_AND_INVENTORY: () => `${BASE}/items-and-inventory`,
  PRODUCTS: () => `${BASE}/items-and-inventory/products`,
  DEAL_COMBOS: () => `${BASE}/items-and-inventory/deals`,
  MEAL_COMBOS: () => `${BASE}/items-and-inventory/meals`,

  REPORTS: () => `${BASE}/reports`,
  HOURS_SALES: () => `${BASE}/reports/period/hours`,
  DAY_WEEK_SALES: () => `${BASE}/reports/period/day-week`,
  MONTH_YEAR_SALES: () => `${BASE}/reports/period/month-year`,
  BRANCH_SALES: () => `${BASE}/reports/location/branch`,
  AREA_SALES: () => `${BASE}/reports/location/area`,
  CALL_CENTER_AGENT_SALES: () => `${BASE}/reports/details/call-center-agent`,
  ITEM_SALES: () => `${BASE}/reports/details/item`,
  PAYMENT_METHOD_SALES: () => `${BASE}/reports/details/payment-method`,
  ORDERING_CHANNEL_SALES: () => `${BASE}/reports/details/ordering-channel`,
  COMBO_SALES: () => `${BASE}/reports/details/combo`,

  MARKETING: () => `${BASE}/marketing`,
  PROMOCODES: () => `${BASE}/marketing/promocodes`,
  PROMOCODE_EDIT: (id: string | number) => `${BASE}/marketing/promocodes/${id}/edit`,
  PROMOCODE_CREATE: () => `${BASE}/marketing/promocodes/create`,
  PROMOBANNERS: () => `${BASE}/marketing/promobanners`,
  PROMOBANNER_EDIT: (id: string | number) => `${BASE}/marketing/promobanners/${id}/edit`,
  PROMOBANNER_CREATE: () => `${BASE}/marketing/promobanners/create`,
  MESSAGE_CAMPAIGNS: () => `${BASE}/marketing/messages`,
  MESSAGE_CAMPAIGN_EDIT: (id: string | number) => `${BASE}/marketing/messages/${id}`,
  MESSAGE_CAMPAIGN_CREATE: () => `${BASE}/marketing/messages/create`,
  DEALS: () => `${BASE}/marketing/deals`,
  DEALS_EDIT: (id: string | number) => `${BASE}/marketing/deals/${id}/edit`,
  DEALS_CREATE: () => `${BASE}/marketing/deals/create`,
  CASHBACK: () => `${BASE}/marketing/cashback`,
  CASHBACK_CREATE: () => `${BASE}/marketing/cashback/create`,
  CASHBACK_EDIT: (id: string | number) => `${BASE}/marketing/cashback/${id}/edit`,

  CRM: () => `${BASE}/crm`,
  CRM_PROFILES: () => `${BASE}/crm/profiles`,
  CRM_PROFILE_EDIT: (id: string | number) => `${BASE}/crm/profiles/${id}/edit`,
  CRM_PROFILE_CREATE: () => `${BASE}/crm/profiles/create`,
  CRM_RESTRICTIONS: () => `${BASE}/crm/restrictions`,
  CRM_RESTRICTIONS_CREATE: () => `${BASE}/crm/restrictions/create`,

  ORDERS_RATING: () => `${BASE}/crm/orders-rating`,
  ORDER_RATING: (id: string) => `${BASE}/crm/orders-rating/${id}`,
  ORDER_RATING_ORDER: (id: string) => `${BASE}/crm/orders-rating/${id}/order`,
  ORDER_RATING_ORDER_EDIT: (id: string) => `${BASE}/crm/orders-rating/${id}/order/edit`,
  ORDER_RATING_ORDER_LOGS: (id: string | number) => `${BASE}/crm/orders-rating/${id}/order/logs`,
  ORDER_RATING_ORDER_TECHNICAL_LOGS: (id: string | number) => `${BASE}/crm/orders-rating/${id}/order/technical-logs`,
  ORDER_RATING_ORDER_TRANSACTION_LOGS: (id: string | number) => `${BASE}/crm/orders-rating/${id}/order/transaction-logs`,
  ORDER_RATING_ORDER_CONTENT_LOGS: (id: string | number) => `${BASE}/crm/orders-rating/${id}/order/content-logs`,

  MARKETPLACE: () => `${BASE}/marketplace`,
  MARKETPLACE_FEATURE: (featureKey: string) => `${BASE}/marketplace/${featureKey}`,

  DELIVERY_MANAGEMENT: () => `${BASE}/delivery-management`,
  DELIVERY_ZONES: () => `${BASE}/delivery-management/delivery-zones`,
  DISPATCHING_RULES: () => `${BASE}/delivery-management/dispatching-rules`,
  DELIVERY_TRACKING: () => `${BASE}/delivery-management/delivery-tracking`,
  DSP_COVERAGE: () => `${BASE}/delivery-management/dsp-coverage`,
  DELIVERY_TRACKING_REQUEST: (id: string | number) => `${BASE}/delivery-management/delivery-tracking/${id}`,
  DISPATCHING_RULES_LOGS: (id: string | number) => `${BASE}/delivery-management/dispatching-rules/${id}/logs`,

  MENU: () => `${BASE}/menu`,
  MENU_GROUPS: () => `${BASE}/menu/menu-groups`,
  MENU_GROUPS_EDIT: (id: string | number) => `${BASE}/menu/menu-groups/${id}/edit`,
  MENU_GROUPS_CREATE: () => `${BASE}/menu/menu-groups/create`,
  MENU_GROUP_IMPROVEMENT: () => `${BASE}/menu/menu-group/improvement`,
  CATEGORIES: () => `${BASE}/menu/categories`,
  CATEGORIES_EDIT: (id: string | number) => `${BASE}/menu/categories/${id}/edit`,
  CATEGORIES_CREATE: () => `${BASE}/menu/categories/create`,
  ITEMS: () => `${BASE}/menu/items`,
  ITEMS_EDIT: (id: string | number) => `${BASE}/menu/items/${id}/edit`,
  ITEMS_BRANCHES_CONFIGURATION: (id: string | number) => `${BASE}/menu/items/${id}/branches/configuration`,
  ITEMS_BRANCHES_MODIFIERS: (id: string | number) => `${BASE}/menu/items/${id}/branches/modifiers`,
  ITEMS_CREATE: () => `${BASE}/menu/items/create`,
  MODIFIERS: () => `${BASE}/menu/modifiers`,
  MODIFIERS_EDIT: (id: string | number) => `${BASE}/menu/modifiers/${id}/edit`,
  MODIFIERS_CREATE: () => `${BASE}/menu/modifiers/create`,
  EXCLUSIONS: () => `${BASE}/menu/exclusions`,
  EXCLUSIONS_EDIT: (id: string | number) => `${BASE}/menu/exclusions/${id}/edit`,
  EXCLUSIONS_CREATE: () => `${BASE}/menu/exclusions/create`,
  MEALS: () => `${BASE}/menu/meals`,
  MEALS_EDIT: (id: string | number) => `${BASE}/menu/meals/${id}/edit`,
  MEALS_CREATE: () => `${BASE}/menu/meals/create`,

  BRANCHES: () => `${BASE}/branches/list`,
  BRANCHES_WORKING_HOURS: () => `${BASE}/branches/profiles`,
  BRANCHES_WORKING_HOURS_LOG: (id: string | number) => `${BASE}/branches/profiles/${id}/log`,
  BRANCHES_CREATE: () => `${BASE}/branches/create`,
  BRANCHES_LOG: () => `${BASE}/branches/log`,
  BRANCH_LOG: (id: string | number) => `${BASE}/branches/${id}/log`,
  BRANCHES_EDIT: (id: string | number) => `${BASE}/branches/${id}/edit`,

  WALLET_TRANSACTION_LOG: () => `${BASE}/crm/wallet/transaction/log`,
  USER_WALLET_TRANSACTION_LOG: (id: string | number) => `${BASE}/crm/profiles/${id}/wallet/transaction/log`,

  PROMOCODE_LOG: () => `${BASE}/promocode/log`,

  // Foodics
  FOODICS_LOG: () => `${BASE}/foodics/log`,

  // Refund
  REFUND_LOG: () => `${BASE}/refund/log`,

  SETTINGS: () => `${BASE}/settings`,
  // general
  SETTINGS_USERS: () => `${BASE}/settings/users/all`,
  SETTINGS_USERS_EDIT: (id: string | number) => `${BASE}/settings/users/${id}/edit`,
  SETTINGS_USER_ROLES: () => `${BASE}/settings/users/roles`,
  SETTINGS_USERS_CREATE: () => `${BASE}/settings/users/create`,

  SETTINGS_COUNTRIES: () => `${BASE}/settings/countries`,
  SETTINGS_COUNTRY_EDIT: (id: string | number) => `${BASE}/settings/countries/${id}/edit`,
  SETTINGS_COUNTRY_CREATE: () => `${BASE}/settings/countries/create`,

  SETTINGS_CURRENCY: () => `${BASE}/settings/currency`,
  SETTINGS_CURRENCY_EDIT: (id: string | number) => `${BASE}/settings/currencies/${id}/edit`,
  SETTINGS_CURRENCY_CREATE: () => `${BASE}/settings/currencies/create`,

  SETTINGS_TRANSLATION: () => `${BASE}/settings/translations`,
  SETTINGS_TRANSLATION_EDIT: (id: string | number) => `${BASE}/settings/translations/${id}/edit`,
  SETTINGS_TRANSLATION_CREATE: () => `${BASE}/settings/translations/create`,

  // ordering channels
  SETTINGS_CONSUMER_CHANNELS_CONFIG: () => `${BASE}/settings/consumer-channels-configuration`,
  SETTINGS_CONSUMER_CHANNELS_CONFIG_MOBILE: () => `${BASE}/settings/consumer-channels-configuration/mobile`,
  SETTINGS_CONSUMER_CHANNELS_CONFIG_WEB: () => `${BASE}/settings/consumer-channels-configuration/web`,
  SETTINGS_CONSUMER_CHANNELS_CONFIG_KIOSK: () => `${BASE}/settings/consumer-channels-configuration/kiosk`,
  SETTINGS_CONSUMER_CHANNELS_CONFIG_DOOK: () => `${BASE}/settings/consumer-channels-configuration/dook`,
  SETTINGS_WEBSITE: () => `${BASE}/settings/website`,
  SETTINGS_WEBSITE_ABOUT: () => `${BASE}/settings/website/about`,
  SETTINGS_WEBSITE_TERMS_CONDITIONS: () => `${BASE}/settings/website/terms-conditions`,
  SETTINGS_WEBSITE_PRIVACY_POLICY: () => `${BASE}/settings/website/privacy-policy`,
  SETTINGS_WEBSITE_CONTACT_US: () => `${BASE}/settings/website/contact-us`,
  SETTINGS_WEBSITE_MANAGE_FAQ: () => `${BASE}/settings/website/manage-faq`,
  SETTINGS_WEBSITE_MANAGE_FAQ_EDIT: (id: string | number) => `${BASE}/settings/website/manage-faq/${id}/edit`,
  SETTINGS_WEBSITE_MANAGE_FAQ_CREATE: () => `${BASE}/settings/website/manage-faq/create`,
  SETTINGS_WEBSITE_COOKIES: () => `${BASE}/settings/website/cookies`,
  SETTINGS_WEBSITE_FRANCHISE: () => `${BASE}/settings/website/franchise`,

  // orders
  SETTINGS_ORDERS: () => `${BASE}/settings/orders`,
  SETTINGS_ORDERS_CONDITIONS: () => `${BASE}/settings/orders/conditions`,
  SETTINGS_ORDERS_NOTES: () => `${BASE}/settings/orders/notes`,
  SETTINGS_PREPARATION_PROFILES: () => `${BASE}/settings/orders/preparation-settings-profiles`,
  SETTINGS_ORDERS_FRANCHISE: () => `${BASE}/settings/orders/franchise`,

  // connections -  integrations
  SETTINGS_INTEGRATIONS: () => `${BASE}/settings/integrations`,
  SETTINGS_INTEGRATION: (integration: string) => `${BASE}/settings/integrations/${integration}`,

  SETTINGS_WEBHOOK: () => `${BASE}/settings/webhook`,
  SETTINGS_WEBHOOK_EDIT: (id: string | number) => `${BASE}/settings/webhook/${id}/edit`,
  SETTINGS_WEBHOOK_CREATE: () => `${BASE}/settings/webhook/create`,

  // communication
  SETTINGS_NOTIFICATIONS: () => `${BASE}/settings/notifications`,
  SETTINGS_NOTIFICATIONS_ORDER_STATUS: () => `${BASE}/settings/notifications/order-status`,
  SETTINGS_NOTIFICATIONS_ORDER_STATUS_CREATE: () => `${BASE}/settings/notifications/order-status/create`,
  SETTINGS_NOTIFICATIONS_ORDER_SYSTEM: () => `${BASE}/settings/notifications/order-system`,
  SETTINGS_NOTIFICATIONS_WALLET: () => `${BASE}/settings/notifications/wallet`,
  SETTINGS_NOTIFICATIONS_WALLET_CREATE: () => `${BASE}/settings/notifications/wallet/create`,
  SETTINGS_NOTIFICATIONS_CURBSIDE: () => `${BASE}/settings/notifications/curbside`,

  // devices
  SETTINGS_DEVICES_KIOSKS: () => `${BASE}/settings/devices/kiosks`,
  SETTINGS_DEVICES_KIOSKS_CREATE: () => `${BASE}/settings/devices/kiosks/create`,
  SETTINGS_DEVICES_KIOSKS_EDIT: (id: string | number) => `${BASE}/settings/devices/kiosks/${id}/edit`,

  GUIDELINE: () => `${BASE}/guideline`,

  ERROR: () => `${BASE}/error`,
  NOT_FOUND: () => `${BASE}/oops`,
};
